import React from 'react';
import cs from 'classnames';
import { Handle, Position } from '@xyflow/react';

const HANDLER_HEIGHT = 26;

const Handler = ({ sourcehandlers, targethandlers, isConnectable, IMGE_H, isSelected }) => {
  let l = sourcehandlers.length;

  return (
    <>
      {targethandlers.map((hander, idx) => (
        <div className="flex relative bottom-[0px] w-full mb-2" key={idx}>
          <div
            className={cs(
              'flex flex-1 justify-start rounded-sm items-center  pl-2 text-[#2D2D2D]',
              `h-[${HANDLER_HEIGHT}px]`,
              isSelected ? 'bg-[#E8F3FE]' : 'bg-[#F8F9FA]',
            )}
          >
            <div style={{ transform: 'scale(0.9)' }}>{hander.portLabel}</div>
          </div>
          <Handle
            type="target"
            position={Position.Left}
            id={hander.targetPort}
            style={{ left: '-10.5px', top: HANDLER_HEIGHT / 2 }}
            isConnectable={isConnectable}
          />
        </div>
      ))}
      {l > 0
        ? sourcehandlers.map((handler, idx) => {
            return (
              <Handle
                key={idx}
                type="source"
                position={Position.Right}
                id={handler.id}
                style={{ right: '-63px', top: IMGE_H / 2, zIndex: 10 }}
                isConnectable={isConnectable}
              />
            );
          })
        : null}
    </>
  );
};
export default Handler;
